import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue-category',
  templateUrl: './issue-category.component.html',
  styleUrls: ['./issue-category.component.css']
})
export class IssueCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
